import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import HeroNew from "@/components/HeroNew";
import StatsStrip from "@/components/home/StatsStrip";
import ServiceFronts from "@/components/home/ServiceFronts";
import BeforeAfter from "@/components/home/BeforeAfter";
import CasesWithTestimonial from "@/components/home/CasesWithTestimonial";
import HowIWork from "@/components/home/HowIWork";
import ProductsTeaser from "@/components/home/ProductsTeaser";
import LatestPosts from "@/components/home/LatestPosts";
import CTAFinal from "@/components/CTAFinal";
import FooterNew from "@/components/FooterNew";

// Home = visão geral. Cada seção resume uma frente e leva à rota
// especializada; nenhum produto em destaque (docs/specs/architecture.md).
const Index = () => (
  <div className="min-h-screen">
    <SEOMeta
      title="Eliveuton Dev | Sites, sistemas e automação com IA para PMEs"
      description="Desenvolvedor fullstack para pequenas e médias empresas: sites que geram contato, sistemas sob medida, CRM e atendimento com IA e consultoria. Diagnóstico gratuito de 30 minutos."
      canonicalUrl="/"
    />
    <NavbarNew />
    <main>
      <HeroNew />
      <StatsStrip />
      <ServiceFronts />
      <BeforeAfter />
      <CasesWithTestimonial />
      <HowIWork />
      <ProductsTeaser />
      <LatestPosts />
      <div className="pt-[70px]">
        <CTAFinal />
      </div>
    </main>
    <FooterNew />
  </div>
);

export default Index;
